import * as React from "react";
const SvgScale = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M8.10059 2.10059V0.100586H0.100586L0.100586 8.10059H2.10059L2.10059 3.51477L7.87887 9.29305L9.29308 7.87884L3.51483 2.10059H8.10059Z" }), /* @__PURE__ */ React.createElement("path", { d: "M17.8997 11.8995H19.8997V19.8995H11.8997V17.8995H16.4854L10.7072 12.1213L12.1214 10.7071L17.8997 16.4853V11.8995Z" }));
export default SvgScale;
